import {
  SelectOptionColors,
  darkSelectOptionColors,
  lightSelectOptionColors,
} from '@databases/model/field';
import { type SelectOption } from '@databases/types/database';

function getNewColorSuggestions(options: SelectOption[]): SelectOption['color'][] {
  const usedTimes = Object.fromEntries(
    SelectOptionColors.map((c) => [c, options.filter((v) => v.color === c).length])
  ) as Record<SelectOption['color'], number>;

  const isUsingSomeLightColors = lightSelectOptionColors.some((c) => usedTimes[c] > 0);
  const isUsingAllLightColors = lightSelectOptionColors.every((c) => usedTimes[c] > 0);
  const isUsingSomeDarkColors = darkSelectOptionColors.some((c) => usedTimes[c] > 0);
  const isUsingAllDarkColors = darkSelectOptionColors.every((c) => usedTimes[c] > 0);

  const colorRange = isUsingSomeDarkColors
    ? isUsingAllDarkColors || isUsingSomeLightColors
      ? SelectOptionColors
      : darkSelectOptionColors
    : isUsingAllLightColors
    ? SelectOptionColors
    : lightSelectOptionColors;

  const usedTimesInRange = Object.entries(usedTimes).flatMap(([c, u]) =>
    colorRange.includes(c as any) ? [u] : []
  );
  const minUsedTimes = usedTimesInRange.reduce(
    (min, val) => Math.min(min, val),
    Infinity
  );
  return colorRange.filter((c) => usedTimes[c] === minUsedTimes);
}

export function pickNewColor(options: SelectOption[]): SelectOption['color'] {
  const suggestions = getNewColorSuggestions(options);

  return suggestions[Math.floor(Math.random() * suggestions.length)];
}
